import { CALL_API, Schemas } from '../../common/middleware/api';

export const PERMISSIONS_REQUEST = 'PERMISSIONS_REQUEST';
export const PERMISSIONS_SUCCESS = 'PERMISSIONS_SUCCESS';
export const PERMISSIONS_FAILURE = 'PERMISSIONS_FAILURE';

export const PERMISSION_UPDATE_REQUEST = 'PERMISSION_UPDATE_REQUEST';
export const PERMISSION_UPDATE_SUCCESS = 'PERMISSION_UPDATE_SUCCESS';
export const PERMISSION_UPDATE_FAILURE = 'PERMISSION_UPDATE_FAILURE';

export const loadPermissions = ({ objectId, objectType, ...options }) => ({
	[CALL_API]: {
		types: [PERMISSIONS_REQUEST, PERMISSIONS_SUCCESS, PERMISSIONS_FAILURE],
		endpoint: 'api/permissions/unpaged',
		request: { objectId, objectType, ...options },
		schema: Schemas.PERMISSION_ARRAY
	},
	objectId,
	objectType
});

export const updatePermission = (id, permission) => ({
	[CALL_API]: {
		types: [PERMISSION_UPDATE_REQUEST, PERMISSION_UPDATE_SUCCESS, PERMISSION_UPDATE_FAILURE],
		endpoint: `api/permissions/${id}`,
		method: 'PUT',
		request: permission,
		schema: Schemas.PERMISSION_ARRAY,
		form: 'editPermission',
		replace: { replace: true }
	}
});